import { GAME_ID, REDUX_ACTIONS, LEVEL_PLAYED_COUNTER } from 'a/cutItOut/data/constants';

export const initialState = {
  hasSeenOnboarding: false,
  lastLevelMastered: 1,
  levelPlayedCounters: Array(LEVEL_PLAYED_COUNTER).fill(0),
  levelsMastered: Array(LEVEL_PLAYED_COUNTER).fill(false),
  practicePlayedCounters: Array(LEVEL_PLAYED_COUNTER).fill(0),
  createdAnimals: [],
};

const sessionReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_LAST_LEVEL_MASTERED:
      return {
        ...state,
        lastLevelMastered: action.payload.level,
      };
    case REDUX_ACTIONS.SET_HAS_SEEN_ONBOARDING:
      return {
        ...state,
        hasSeenOnboarding: true,
      };
    case REDUX_ACTIONS.SET_LEVEL_MASTERED: {
      const levelsMastered = state.levelsMastered.slice();
      levelsMastered[action.payload.level] = true;
      return {
        ...state,
        levelsMastered,
      };
    }
    case REDUX_ACTIONS.INCREMENT_LEVEL_PLAYED_COUNTER: {
      const levelPlayedCounters = state.levelPlayedCounters.slice();
      levelPlayedCounters[action.payload.level - 1] += 1;
      return {
        ...state,
        levelPlayedCounters,
      };
    }
    case REDUX_ACTIONS.INCREMENT_PRACTICE_PLAYED_COUNTER: {
      const practicePlayedCounters = state.practicePlayedCounters.slice();
      practicePlayedCounters[action.payload.level - 1] += 1;
      return {
        ...state,
        practicePlayedCounters,
      };
    }
    case REDUX_ACTIONS.ADD_CREATED_ANIMAL: {
      const createdAnimals = state.createdAnimals.slice();
      createdAnimals.push(action.payload);
      return {
        ...state,
        createdAnimals,
      };
    }
    default:
      return state;
  }
};

export default sessionReducer;
